<template>
  <div class="order-list">
    <div
      class="item"
      v-for="(item, index) in lists"
      :key="index"
      @click="onClick(item)"
    >
      <div class="title">
        <p class="order-number">订单编号：{{ item.order_number }}</p>
        <p class="order-status">{{ item.descData.text.list }}</p>
      </div>
      <div class="content">
        <p class="name">{{ item.title }}</p>
        <p class="time">
          时间：{{ item.created_at | fomartTime("yyyy.MM.dd hh:mm") }}
        </p>
        <p class="price">
          <span>实付款：</span>
          <icon-price :priceType="orderType == 4 ? 2 : 1"></icon-price>
          <span>{{ item.order_price | toFixPrice }}</span>
        </p>
        <p class="ship" v-if="orderType == 4">
          物流：{{
            `${item.ship_status_name} ${item.logistics_name ||
              ""} ${item.logistics_no || ""}`
          }}
        </p>
      </div>
      <div class="bottom">
        <order-buttons
          :data="item"
          :order-type="orderType"
          @on-reset="onReset"
          @on-eval="onEval"
          @on-invite="onInvite"
        ></order-buttons>

      </div>
    </div>
    <Share ref="share" :group-id="curGroupID"></Share>
  </div>
</template>

<script>
import { OrderStatus, ShipStatus } from "@/util/enums";
import Share from "@/components/group/Share.vue";
import OrderButtons from "./OrderButtons.vue";
export default {
  name: "order-list",
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    orderType: {
      required: true
    }
  },
  components: {
    OrderButtons,
    Share
  },
  data() {
    return {
      event: {
        onReset: "onReset",
        onComment: "onComment"
      },
      curGroupID: 0
    };
  },
  computed: {
    lists() {
      const ret = this.list;
      ret.forEach(i => {
        i.descData = this.$pub.order.getListDescData(i);
        i.order_status_name = OrderStatus.getValue(i.order_status);
        i.ship_status_name = ShipStatus.getValue(i.ship_status);
      });
      return ret;
    }
  },
  created() {},
  methods: {
    // on event
    onClick(item) {
      this.$router.push({
        name: "OrderDetail",
        query: {
          order_id: item.id,
          order_type: this.orderType
        }
      });
    },
    onEval(type,item) {
      this.$emit(this.event.onComment, item);
    },
    onInvite(data) {
      this.curGroupID = data.group_id;
      this.$nextTick(() => {
        this.$refs.share.display();
      });
    },
    onReset() {
      this.$emit(this.event.onReset);
    },
    onRefund(item) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "申请退款及具体退款金额需要管理员审核，确认退款么？"
        })
        .then(() => {
          this.$http.get(`/api/app/myOrder/application/${item.id}`).then(() => {
            this.$emit(this.event.onReset);
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.order-list {
  padding: 30px;
  .item {
    background-color: #fff;
    border-radius: 10px;
    padding: 30px 28px;
    margin-bottom: 30px;
    position: relative;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
    .title {
      display: flex;
      justify-content: space-between;
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid #f5f5f5;
      .order-number {
        font-size: 24px;
        color: #595959;
      }
      .order-status {
        font-size: 24px;
        color: #ea7a2f;
      }
    }
    .content {
      margin-bottom: 10px;
      font-size: 24px;
      color: #8c8c8c;
      .name {
        font-size: 26px;
        color: #595959;
        line-height: 30px;
      }
      .time {
        margin-top: 20px;
      }
      .price {
        margin-top: 15px;
        span:nth-of-type(2) {
          font-size: 32px;
          color: #595959;
        }
        /deep/ .price-ico {
          width: 24px;
          margin-right: 3px;
        }
      }
      .ship {
        margin-top: 15px;
      }
    }
    .bottom {
      text-align: right;
      .btn {
        display: inline-block;
        width: 152px;
        height: 56px;
        border-radius: 28px;
        border: 1px solid #d9d9d9;
        font-size: 24px;
        color: rgba(89, 89, 89, 1);
        line-height: 56px;
        text-align: center;
        margin-left: 20px;
      }
      .color {
        border: 1px solid #ea7a2f;
        color: #ea7a2f;
      }
      .text {
        margin-left: 20px;
      }
      .refund {
        font-size: 24px;
        color: #e02020;
      }
      .cancel {
        font-size: 24px;
        color: #8c8c8c;
      }
    }
  }
}
</style>
